import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d0f824"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-icon"
}
const _hoisted_2 = ["data-icon"]
const _hoisted_3 = {
  key: 1,
  class: "validation-icon is-success"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "iconify",
  "data-icon": "feather:check"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "validation-icon is-error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "iconify",
  "data-icon": "feather:x"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { computed } from 'vue'

export interface VControlProps {
  icon?: string
  isValid?: boolean
  hasError?: boolean
  loading?: boolean
  expanded?: boolean
  textaddon?: boolean
  nogrow?: boolean
  subcontrol?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    icon: { default: undefined },
    isValid: { type: Boolean },
    hasError: { type: Boolean },
    loading: { type: Boolean },
    expanded: { type: Boolean },
    textaddon: { type: Boolean },
    nogrow: { type: Boolean },
    subcontrol: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { icon: string, isValid?: boolean, hasError?: boolean, loading?: boolean, expanded?: boolean, textaddon?: boolean, nogrow?: boolean, subcontrol?: boolean }

const name='VControl'


const isIconify = computed(() => {
  return props.icon && props.icon.indexOf(':') !== -1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["control", [
      __props.icon && 'has-icon',
      __props.loading && 'is-loading',
      __props.expanded && 'is-expanded',
      __props.nogrow && 'is-nogrow',
      __props.textaddon && 'is-textarea-addon',
      __props.isValid && 'has-validation has-success',
      __props.hasError && 'has-validation has-error',
      __props.subcontrol && 'subcontrol',
    ]])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(isIconify))
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                "aria-hidden": "true",
                class: "iconify",
                "data-icon": __props.icon
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                "aria-hidden": "true",
                class: _normalizeClass(__props.icon)
              }, null, 2))
        ]))
      : _createCommentVNode("", true),
    (__props.isValid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (__props.hasError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "extra")
  ], 2))
}
}

})